import React, { createContext, useContext } from 'react';

const ImageContext = createContext();

export const useImages = () => {
  return useContext(ImageContext);
};

export const ImageProvider = ({ children }) => {
  const initialImages = [
    'assets/images/circles/img1.svg',
    'assets/images/circles/img2.svg',
    'assets/images/circles/img3.svg',
    'assets/images/circles/img4.svg',
    'assets/images/circles/img5.svg',
    'assets/images/circles/img6.svg',
    'assets/images/circles/img7.svg',
    'assets/images/circles/img8.svg',
    'assets/images/circles/img9.svg',
    'assets/images/circles/img10.svg',
    'assets/images/circles/img11.svg',
    'assets/images/circles/img12.svg',
    'assets/images/circles/img13.svg',
    'assets/images/circles/img14.svg',
    'assets/images/circles/img15.svg',
    'assets/images/circles/img16.svg',
    'assets/images/circles/img17.svg',
    'assets/images/circles/img18.svg',
    'assets/images/circles/img19.svg',
    'assets/images/circles/img20.svg',
  ];

  return (
    <ImageContext.Provider value={initialImages}>
      {children}
    </ImageContext.Provider>
  );
};
